import { CUSTOM_ELEMENTS_SCHEMA, Component, Input } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { ExpedienteNotaDto } from '@models/expedienteNota/expedienteNotaDto.model';
import { ExpedienteNotaService } from '@services/expedienteNota/expedienteNota.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { AccionesDialog } from '@models/base/identificadores.model';
import { DialogExpedienteNotaUpdateComponent } from '../dialog-expediente-nota-update/dialog-expediente-nota-update.component';
import { DialogExpedienteNotaCreateComponent } from '../dialog-expediente-nota-create/dialog-expediente-nota-create.component';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { ButtonEditComponent } from 'src/app/component/button-edit/button-edit.component';
import { ButtonCancelComponent } from 'src/app/component/button-cancel/button-cancel.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { AvatarInicialesComponent } from 'src/app/component/avatar-iniciales/avatar-iniciales.component';

@Component({
  standalone: true,
    imports: [AppRolesDirective, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule,MatTabsModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, ButtonNewComponent,  ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, CommonModule, FormsModule, MatSortModule, NgxSpinnerModule, FormsModule, ReactiveFormsModule, CommonModule, ButtonNewComponent, MatTooltipModule, MatPaginatorModule, MatRippleModule,AvatarInicialesComponent],
  selector: 'app-list-expediente-nota',
  templateUrl: './list-expediente-nota.component.html',
  styleUrls: ['./list-expediente-nota.component.css'],

})
export class ListExpedienteNotaComponent {


  @Input() idExpediente!: number
  expedienteNotas!: ExpedienteNotaDto[];
  panelOpenState = false;

  constructor(
    private dialog: MatDialog,
    private expedienteNotaService: ExpedienteNotaService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,

  ) {
  }
  ngOnInit() {
    if (!isFalsy(this.idExpediente))
      this.getAllByIdExpediente(this.idExpediente)
  }


  getAllByIdExpediente(idExpediente: number) {
    this.spinner.show("spLoadList")
    this.expedienteNotaService.getAllByIdExpediente(idExpediente)
      .subscribe(
        data => {
          this.spinner.hide("spLoadList")
          this.expedienteNotas = data.sort((b, a) => a.fechaAlta.toString().localeCompare(b.fechaAlta.toString()))
        },
        error => {
          this.spinner.hide("spLoadList")
          this.snackBar.showError(error, "Error");
        })
  }

  openDialog(action: any, obj: any) {
    obj.action = action;
    obj.idExpediente = this.idExpediente;
    // if (obj.action != AccionesDialog.Cancelar && obj.action != AccionesDialog.Agregar) {
    //   obj.id = obj.item.id;
    //   obj.descripcion = obj.item.descripcion;
    //   obj.item = obj.item;
    // }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "50%",
    dialogConfig.data = obj
    let dialogRef: any;
    switch (action) {
      case AccionesDialog.Modificar:
        dialogRef = this.dialog.open(DialogExpedienteNotaUpdateComponent,
          dialogConfig);

        dialogRef.afterClosed().subscribe((result: { event: AccionesDialog; }) => {
          if (result.event != AccionesDialog.Cancelar) {
            this.getAllByIdExpediente(this.idExpediente)
          }
        });
        break;
      case AccionesDialog.Agregar:
          dialogRef = this.dialog.open(DialogExpedienteNotaCreateComponent,
            dialogConfig);

          dialogRef.afterClosed().subscribe((result: { event: AccionesDialog; }) => {
            if (result.event != AccionesDialog.Cancelar) {
              this.getAllByIdExpediente(this.idExpediente)
            }
          });
        break;
        case AccionesDialog.Eliminar:
          dialogConfig.width = "25%",
          dialogRef = this.dialog.open(DialogDeleteComponent,
            dialogConfig);

          dialogRef.afterClosed().subscribe((result: { event: AccionesDialog; }) => {
            if (result.event != AccionesDialog.Cancelar) {
              this.getAllByIdExpediente(this.idExpediente)
            }
          });
          break;
      default:
        break;
    }

  }

  getDescripcionCorta(html: string | null | undefined, length: number = 100): string {
    if (!html) return '';  // Si es null, undefined o vacío, devuelve string vacío
    const textoPlano = html.replace(/<[^>]+>/g, ''); // Elimina etiquetas HTML
    return textoPlano.length > length ? textoPlano.slice(0, length) + '...' : textoPlano;
  }

}
